import React from "react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    quote: "PMS transformed how our agency manages client projects. The credentials manager alone saved us hours of back-and-forth with clients.",
    name: "Alex Lee",
    role: "CEO, DesignLab Agency",
    initials: "AL",
    gradient: "bg-blue-500",
    rating: 5
  },
  {
    quote: "The real-time collaboration features are incredible. Our remote team finally feels connected. We've increased productivity by 40% since switching.",
    name: "Maria Kim",
    role: "Project Manager, TechCorp",
    initials: "MK",
    gradient: "bg-green-500",
    rating: 5
  },
  {
    quote: "Finally, a project management tool that doesn't overwhelm. Clean interface, powerful features, and the Kanban boards are exactly what we needed.",
    name: "James Davis",
    role: "CTO, StartupX",
    initials: "JD",
    gradient: "bg-indigo-500",
    rating: 5
  }
];

const StarRow = ({ rating }) => (
  <div className="flex items-center gap-1 mb-4">
    {Array.from({ length: 5 }).map((_, idx) => (
      <Star
        key={idx}
        className={`w-5 h-5 ${idx < rating ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`}
      />
    ))}
  </div>
);

const MarketingTestimonials = ({ className = "" }) => {
  return (
    <section className={`curved-section shell-white section-animate ${className}`}>
      <div className="max-w-[95rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="section-eyebrow reveal">Testimonials</span>
          <h2 className="reveal stagger-1 mt-4 mb-6">
            Loved by teams <span className="text-navy">worldwide</span>
          </h2>
          <p className="text-lead reveal stagger-2">
            See what our customers have to say about PMS.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((item, idx) => (
            <div
              key={item.name}
              className={`card-marketing card-hover reveal stagger-${idx + 1}`}
            >
              <div className="flex justify-between items-start mb-6">
                <StarRow rating={item.rating} />
                <Quote className="w-8 h-8 text-blue-100" />
              </div>
              <p className="text-body mb-8 italic">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-gray-50">
                <div
                  className={`w-12 h-12 rounded-full ${item.gradient} flex items-center justify-center text-white font-bold text-lg shadow-inner`}
                >
                  {item.initials}
                </div>
                <div>
                  <div className="font-bold text-gray-900">{item.name}</div>
                  <div className="text-sm text-gray-500">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketingTestimonials;
